<div class="header">
  <div class="header-cont tables">
    <h2>{{ 'admin_itin.title' | translate }}</h2>
    <button mat-raised-button class="page-header-btns add-element" [routerLink]="['/lista-itinerari/nuovo-itinerario']">
      <mat-icon>add_location</mat-icon>
    </button>
  </div>
</div>

<div class="single-section">
  <div class="section-cont tables">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'admin_itin.search_label' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingItin; else loadingList" matSuffix>search</mat-icon>
      <ng-template #loadingList>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="admin-table">
  <table mat-table [dataSource]="dataSource">
    <!-- Itin name Column -->
    <ng-container matColumnDef="itin_name">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_itin.columns.itin' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.itin_name[current_lang]}}
      </td>
    </ng-container>

    <!-- POIs list Column -->
    <ng-container matColumnDef="pois_list">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_itin.columns.pois' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{listOfPois(row)}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [routerLink]="['/lista-itinerari/'+row.id]">
    </tr>
  </table>

  <mat-paginator class="mat-paginator-sticky" [pageSize]="itin_list_size" [length]="itin_list_total"></mat-paginator>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
